const translation: any = {
	doctor: {
		login: {
			panelName: "پزشکان",
		},
		dashboard: {
			totalUsers: "تعداد بیماران ثبت شده",
		},
		userShow: {
			title: "مشاهده پروفایل بیمار",
		},
		userEdit: {
			title: "ویرایش پروفایل بیمار",
		},
		userCreate: {
			title: "ثبت اطلاعات بیمار",
			fName: "نام بیمار",
			lName: "نام خانوادگی بیمار",
			mobile: "شماره همراه بیمار",
			comment: "توضیحات",
			button: "ثبت اطلاعات بیمار",
			notifySuccessMsg: "پروفایل بیمار با موفقیت ایجاد شد",
			notifyFailedMsg: "ایجاد پروفایل بیمار ناموفق بود",
		},
		userList: {
			title: "لیست بیماران",
			createButton: "بیمار",
			comment: "توضیحات دکتر",
		},
		operator: {
			allUser: {
				title: "لیست کل بیماران",
			},
			newUsers: {
				title: "لیست بیماران جدید",
			},
		},
	},
	admin: {
		login: {
			panelName: "ادمین",
		},
		dashboard: {
			totalUsers: "تعداد کل کاربران ثبت شده",
		},
		userShow: {
			title: "مشاهده پروفایل کاربر",
		},
		userEdit: {
			title: "ویرایش پروفایل کاربر",
		},
		userCreate: {
			title: "ثبت اطلاعات کاربر",
			fName: "نام کاربر",
			lName: "نام خانوادگی کاربر",
			mobile: "شماره همراه کاربر",
			comment: "توضیحات",
			button: "ثبت اطلاعات کاربر",
			notifySuccessMsg: "پروفایل کاربر با موفقیت ایجاد شد",
			notifyFailedMsg: "ایجاد پروفایل کاربر ناموفق بود",
		},
		userList: {
			title: "لیست کاربران",
			createButton: "کاربر",
			comment: "توضیحات ادمین",
		},
		operator: {
			allUser: {
				title: "لیست کل کاربران",
			},
			newUsers: {
				title: "لیست کاربران جدید",
			},
		},
	},
	sport_coach: {
		login: {
			panelName: "مربیان",
		},
		dashboard: {
			totalUsers: "تعداد ورزشکاران ثبت شده",
		},
		userShow: {
			title: "مشاهده پروفایل ورزشکار",
		},
		userEdit: {
			title: "ویرایش پروفایل ورزشکار",
		},
		userCreate: {
			title: "ثبت اطلاعات ورزشکار",
			fName: "نام ورزشکار",
			lName: "نام خانوادگی ورزشکار",
			mobile: "شماره همراه ورزشکار",
			comment: "توضیحات",
			button: "ثبت اطلاعات ورزشکار",
			notifySuccessMsg: "پروفایل ورزشکار با موفقیت ایجاد شد",
			notifyFailedMsg: "ایجاد پروفایل ورزشکار ناموفق بود",
		},
		userList: {
			title: "لیست ورزشکاران",
			createButton: "ورزشکار",
			comment: "توضیحات مربی",
		},
		operator: {
			allUser: {
				title: "لیست کل ورزشکاران",
			},
			newUsers: {
				title: "لیست ورزشکاران جدید",
			},
		},
	},
};

export default translation[`${process.env.REACT_APP_TRANSLATION_ROLE}`];
